class Container {
  constructor() { this.init() }
  init() {
    this.stores = {}
    this.actions = {}
  }
  register(type, name, component) {
    this[type][name] = component
    return component
  }
  registerStore(name, component) { return this.register('stores', name, component) }
  registerAction(name, component) { return this.register('actions', name, component) }
  getStore(name) { return this.stores[name] }
  getAction(name) { return this.actions[name] }
}

export default new Container()
